<script setup>
const emit = defineEmits(["input", "showConfirmation"]);

const props = defineProps({
  inputId: {
    type: String,
    default: "toggler-input-id",
  },

  value: Boolean,

  withConfirmation: {
    type: Boolean,
    default: false,
  },
});

function onToggle() {
  if (props.withConfirmation) {
    emit("showConfirmation");
  } else {
    emit("input", !props.value);
  }
}
</script>

<template>
  <label
    class="form-switch"
    :class="{ 'form-switch--on': value }"
  >
    <input
      :id="inputId"
      type="checkbox"
      :checked="value"
      class="form-switch__input"
      @click="onToggle"
    >
    <span class="form-switch__slider" />
  </label>
</template>

<style lang="scss" scoped>
@use "@Sass/bootstrap/customization/_colors.scss" as colors;

.form-switch {
  $self: &;

  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
  margin: 0;

  &__input {
    width: 0;
    height: 0;
    opacity: 0;
  }

  &__slider {
    position: absolute;
    inset: 0; // shorthand for top, right, bottom, left
    border: 1px solid colors.$gray-300;
    background-color: white;
    border-radius: 20px;
    transition: background-color 0.2s;

    &::before {
      content: "";
      position: absolute;
      width: 12px;
      height: 12px;
      bottom: 3px;
      left: 3px;
      background-color: #bbbbbb;
      border-radius: 50%;
      transition: transform 0.4s;
    }
  }

  &:focus-within {
    box-shadow: 0 0 0 0.2rem colors.$green-30;
  }

  &--on {
    #{$self}__slider {
      background-color: colors.$blue;

      &::before {
        background-color: colors.$white;
        transform: translateX(16px);
      }
    }
  }
}
</style>
